import { I18n } from '@ies/starling_intl';

import Starling from '@ies/starling_client';
import { getUserInfo } from '@/apis/user';
// import { useCommonModel } from '@/models';

// import { I18N_STATUS } from '@/assets/const/storageKeys';

const getDefaultLang = () => {
  let lang = localStorage.getItem('I18N_STATUS');
  if (lang) {
    return lang;
  }
  if (['zh-CN', 'zh'].includes(navigator.language)) {
    lang = 'zh-CN';
  } else {
    lang = 'en';
  }
  return lang;
};

export const defaultLang = getDefaultLang();
// export const defaultLang = 'en';
/** 当前语言是不是中文 */
export const isLangZH = defaultLang === 'zh-CN';

export const initStarling = async () => {
  let lang = localStorage.getItem('I18N_STATUS');
  try {
    if (
      !['/login', '/signout', '/', '/noPermission/download'].includes(
        window.location.pathname,
      )
    ) {
      const { userInfo } = await getUserInfo();
      if (!lang) {
        if (userInfo.userType === 5) {
          lang = 'en';
        } else {
          lang = 'zh-CN';
        }
      }
    } else {
      lang = lang || 'zh-CN';
    }
  } catch (error) {
  } finally {
    Object.defineProperty(window.navigator, 'language', { value: lang });
    localStorage.setItem('I18N_STATUS', lang || defaultLang);
    await I18n.init({
      // 其它配置项
      lng: lang || defaultLang,
      fallbackLng: [lang || defaultLang],
    });
    await setLocale(lang || defaultLang);
  }
};

/** 拉取平台上的翻译文案 */
export const setLocale = async (locale = defaultLang) => {
  localStorage.setItem('I18N_STATUS', locale);
  const starling = new Starling({
    api_key: '83470710bffe11ea8b1a2df6d3a0dd3c',
    namespace: ['GameFlow'],
    locale,
    timeout: 1000,
    test: false, // 如果要抓取测试环境的文案，改成 true 即可
    zoneHost: 'https://starling.zijieapi.com', // 文案获取接口域名，v3 新增
    fallbackLang: ['en'],
  });
  I18n.setLang(locale);

  const texts = await starling.load(data => {
    (window as any).$i18n = (key, params, value) => {
      let str = data[key] || value;
      const keys = Object.keys(params || {});
      keys.forEach(
        k => (str = str.replace(new RegExp(`{${k}}`, 'g'), params[k])),
      );
      return str;
    };
  });

  I18n.addResourceBundle(locale, 'translation', texts || {});
};

/** 获取当前语言的 key */
export const getLang = () => {
  return (I18n as any).i18nInstance.userLng?.split('-')[0] as string;
};
